module.exports = __webpack_public_path__ + "img/261-4.9b4aceef.png";